import jQuery from 'jquery/dist/jquery.slim';

(function ($) {
  /*
  - the opco script checks the top level window location to see if it contains #noredirect,
  - if it does not, then it performs a redirect to 'https://www.opco.com/ClientAccess/login/redirect',
  - when that detects the user is not logged in it redirects the user to 'https://www.oppenheimer.com/client-login.aspx#nodirect'
    NOTE: THIS URL IS HARDCODED IN THE OPCO SCRIPT, THEY MUST CHANGE IT!!!
  - the opco script injected in this page will then see '#nodirect' in the url and remove it from the url
  - then it will inject the login iframe into the #icaLogin container

  THIS MAKES AUTHORING THE PAGE A CHALLENGE BECAUSE IT WANTS TO REDIRECT AS SOON AS YOU LOAD IT,
  AND THE URL THAT OPCO REDIRECTS BACK TO WILL NOT BE CORRECT FOR NON-PROD ENVIRONMENTS.
  */

  const loginPageContainer = document.querySelector('.login-page-container');
  if (loginPageContainer === null) {
    return;
  }

  const scriptUrl = loginPageContainer.dataset.loginUrl;
  const loadingElement = document.getElementById('icaLoading');
  const loadingFailedElement = document.getElementById('icaFailedLoading');
  const loginElement = document.getElementById('icaLogin');
  const announcementElement = document.getElementById('icaAnnouncement');
  const bannerElement = document.getElementById('icaBanner');

  if (loginPageContainer.dataset.appendHash === 'true') {
    // prevent redirect which would send us to opco.com on first load
    window.location.hash = '#nodirect';
  }

  function showLogin() {
    loginElement.style.display = 'block';
  }

  function hideLoading() {
    loadingElement.style.display = 'none';
  }

  function showLoadingFailed() {
    loadingFailedElement.style.display = 'block';
  }

  function showBanner() {
    bannerElement.style.display = 'block';
  }

  function requestLoadAnnouncement() {
    window.requestAnimationFrame(loadAnnouncement);
  }

  function loadAnnouncement() {
    // try to find iframe injected by login script
    const iframe = document.querySelector('#icaLogin iframe');

    // try again until the iframe is found
    if (iframe === null) {
      requestLoadAnnouncement();
      return;
    }

    // show announcements if any were injected into page
    if (announcementElement.childElementCount > 0) {
      showBanner();
    }
  }

  function loadLoginScript() {
    window.$ = $;

    const script = document.createElement('script');

    script.onload = () => {
      hideLoading();

      // check for new global var set by injected script
      if (window.icaLoaded) {
        showLogin();
      } else {
        showLoadingFailed();
      }
    };

    script.onerror = function () {
      hideLoading();
      showLoadingFailed();
    };

    script.src = scriptUrl;
    document.head.appendChild(script);
  }

  loadLoginScript();
})(jQuery);
